var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8159 14.3184L12.5007 15.6048L11.1855 14.3184",
    stroke: "#F5B335",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8477 14.9668L10.5469 21.43L12.5005 23.4004",
    stroke: "#F5B335",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1528 14.9668L14.4536 21.43L12.5 23.4004",
    stroke: "#F5B335",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1008 20.4263L21.28 19.3535L20.5912 15.9263C20.4387 15.168 20.0303 14.485 19.4344 13.9919C19.109 13.7056 18.7197 13.5015 18.2992 13.3967L15.3808 12.5447C15.3177 12.5269 15.2578 12.4994 15.2032 12.4631C15.1249 12.4112 15.0587 12.3429 15.0094 12.2629C14.9601 12.1829 14.9288 12.0932 14.9176 11.9999L14.7832 10.8431C15.6331 10.1603 16.2359 9.2178 16.4992 8.15988C17.0224 8.11188 17.4232 7.53108 17.4232 6.79908C17.4232 6.11988 17.0824 5.57268 16.6168 5.45508",
    stroke: "#F5B335",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35946 5.45801C7.90586 5.58521 7.57706 6.12521 7.57706 6.79241C7.57706 7.52441 7.97546 8.10521 8.49866 8.15321C8.76159 9.2153 9.36413 10.1625 10.2147 10.8508L10.0803 12.0004C10.07 12.0919 10.04 12.18 9.99233 12.2587C9.94468 12.3374 9.88051 12.4049 9.80426 12.4564C9.74969 12.4927 9.68976 12.5203 9.62666 12.538L6.71066 13.3924C6.28691 13.4989 5.89454 13.7045 5.56586 13.9924C4.96904 14.4848 4.56044 15.1681 4.40906 15.9268L3.72266 19.354L8.35706 20.314",
    stroke: "#F5B335",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6152 5.44761C16.6152 5.44761 16.8576 0.599609 12.4992 0.599609C8.14083 0.599609 8.35923 5.45721 8.35923 5.45721",
    stroke: "#F5B335",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66016 3.37248C8.84406 3.02389 9.15255 2.75739 9.52416 2.62608C10.1146 2.41008 10.777 2.58288 11.3482 2.84448C12.1738 3.22128 12.8962 3.66528 13.8226 3.76608C14.6749 3.88732 15.5439 3.74583 16.3138 3.36048",
    stroke: "#F5B335",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5655 5.29004H9.57832C9.49084 5.29004 9.41992 5.36096 9.41992 5.44844V6.60764C9.41992 6.69512 9.49084 6.76604 9.57832 6.76604H11.5655C11.653 6.76604 11.7239 6.69512 11.7239 6.60764V5.44844C11.7239 5.36096 11.653 5.29004 11.5655 5.29004Z",
    stroke: "#F5B335",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.421 5.29004H13.4338C13.3463 5.29004 13.2754 5.36096 13.2754 5.44844V6.60764C13.2754 6.69512 13.3463 6.76604 13.4338 6.76604H15.421C15.5085 6.76604 15.5794 6.69512 15.5794 6.60764V5.44844C15.5794 5.36096 15.5085 5.29004 15.421 5.29004Z",
    stroke: "#F5B335",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7227 5.83203H13.2755",
    stroke: "#F5B335",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.35742 5.29004L9.42062 5.76284",
    stroke: "#F5B335",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5801 5.76284L16.6193 5.29004",
    stroke: "#F5B335",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8873 11.7363L12.4993 13.8747L10.1113 11.7363",
    stroke: "#F5B335",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3145 17.4815L19.0145 16.9727",
    stroke: "#F5B335",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.2e6a4aaa35d0aebd00dc855d61996134.svg";
export { ForwardRef as ReactComponent };